import { Moon, Sun } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <button
      data-testid="theme-toggle"
      onClick={toggle}
      aria-label="Toggle theme"
      className="w-10 h-10 rounded-full grid place-items-center border-2 border-su-border bg-su-surface hover:scale-110 transition-transform"
    >
      {theme === "dark" ? <Sun className="w-5 h-5 text-su-secondary" /> : <Moon className="w-5 h-5 text-su-primary" />}
    </button>
  );
}
